import React from "react";
import ReactMarkdown, { Components } from "react-markdown";

interface CustomReactMarkdownProps {
    children: string;
    className?: string;
}

const CustomReactMarkdown: React.FC<CustomReactMarkdownProps> = ({
    children,
    className = "text-gray-800 leading-relaxed",
}) => {
    const components: Components = {
        h1: ({ node, ...props }) => (
            <h1
                className="text-4xl font-bold text-gray-900 mt-8 mb-4 border-b pb-2"
                {...props}
            />
        ),
        h2: ({ node, ...props }) => (
            <h2
                className="text-3xl font-semibold text-gray-900 mt-6 mb-3"
                {...props}
            />
        ),
        h3: ({ node, ...props }) => (
            <h3
                className="text-2xl font-medium text-gray-900 mt-5 mb-2"
                {...props}
            />
        ),
        h4: ({ node, ...props }) => (
            <h4
                className="text-xl font-medium text-gray-900 mt-4 mb-2"
                {...props}
            />
        ),
        h5: ({ node, ...props }) => (
            <h5
                className="text-lg font-medium text-gray-900 mt-3 mb-1"
                {...props}
            />
        ),
        h6: ({ node, ...props }) => (
            <h6
                className="text-base font-medium text-gray-900 mt-3 mb-1"
                {...props}
            />
        ),
        p: ({ node, ...props }) => <p className="mb-4" {...props} />,
        ul: ({ node, ...props }) => (
            <ul className="list-disc pl-6 mb-4 space-y-0.5" {...props} />
        ),
        ol: ({ node, ...props }) => (
            <ol className="list-decimal pl-6 mb-4 space-y-0.5" {...props} />
        ),
        li: ({ node, ...props }) => <li className="mb-0.5" {...props} />,
        a: ({ node, ...props }) => (
            <a
                className="text-blue-600 hover:text-blue-800 underline"
                {...props}
            />
        ),
        blockquote: ({ node, ...props }) => (
            <blockquote
                className="border-l-4 border-gray-300 pl-4 italic my-4 text-gray-600"
                {...props}
            />
        ),
        code: ({
            inline,
            ...props
        }: { inline?: boolean } & React.ComponentPropsWithoutRef<"code">) =>
            inline ? (
                <code
                    className="bg-gray-100 rounded px-1 py-0.5 font-mono text-sm"
                    {...props}
                />
            ) : (
                <code
                    className="block bg-gray-100 rounded p-2 font-mono text-sm overflow-x-auto my-4"
                    {...props}
                />
            ),
        pre: ({ node, ...props }) => <pre className="my-4" {...props} />,
    };

    return (
        <div className={className}>
            <ReactMarkdown components={components}>{children}</ReactMarkdown>
        </div>
    );
};

export default CustomReactMarkdown;
